import { decode } from "@msgpack/msgpack";

export var SseMsgpackController = {
  messageHandlers: new Map(),
  
  init: function (url) {
    SseMsgpackController.eventSource = new EventSource(url);
    SseMsgpackController.eventSource.onmessage = event => {
      const message = decode(new Uint8Array(event.data));
      SseMsgpackController.messageHandlers.forEach((handler, key) => {
        if (message.type == key) {
          handler(message);
        }
      });
    };
  },
  addMessageHandler: function (messageType, handler) {
    SseMsgpackController.messageHandlers.set(messageType, handler);
  },
  removeMessageHandler: function (messageType) {
    SseMsgpackController.messageHandlers.delete(messageType);
  }
};
  